import { axios } from 'apis';
import { Product } from 'models';

const ENDPOINT = 'Products';
export const ProductService = {
	getAll: async () => {
		const response = await axios.get(`${ENDPOINT}`);
		return (await response.data) as Product[];
	},
	create: async (product: Product) => {
		const response = await axios.post(`${ENDPOINT}`, product);
		return response.data as Product;
	},
	update: async (product: Product) => {
		const response = await axios.put(`${ENDPOINT}`, product);
		return response.data as Product;
	},
	delete: async (id: number) => {
		const response = await axios.delete(`${ENDPOINT}/${id}`);
		return response.data as Product;
	},
};